// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Box, Card, Typography } from '../base';

type Variant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'caption'
  | 'button'
  | 'overline';

interface Props {
  title: string;
  titleVariant?: Variant;
  children?: React.ReactNode;
}
export default function TitleCard({ title, children, titleVariant: titleVariantIn }: Props) {
  const titleVariant = titleVariantIn == null ? 'h3' : titleVariantIn;
  return (
    <Card>
      <Box
        component="div"
        sx={{
          alignItems: 'center',
          display: 'flex',
          borderBottom: '1px solid',
          borderBottomColor: 'divider',
          p: { xs: 1, sm: 2 },
        }}
      >
        <Typography variant={titleVariant}>{title}</Typography>
      </Box>
      {children}
    </Card>
  );
}
